import React from "react";
import SVG from "react-inlinesvg";
import { t } from "ttag";

import iconXClose from "../../../../img/icons/x-close.svg";

interface IProps {
    closeButtonRef: (elem: HTMLButtonElement | null) => void;
    onCloseButtonClick: () => void;
    prefixNameCapped: string;
}

export const ConfiguratorPanelHeadAlternative = (
    props: IProps,
): React.JSX.Element => {
    return (
        <div className="configurator__panel--head">
            <h5>{props.prefixNameCapped}</h5>
            <button
                ref={props.closeButtonRef}
                aria-label={t`Close`}
                onClick={props.onCloseButtonClick}
            >
                <SVG aria-hidden="true" src={iconXClose} />
            </button>
        </div>
    );
};
